import { useEffect, useState } from "react";
import { CtaButton } from "@/components/landing/ui";

// Mobile-only bar that follows the visitor once they've scrolled past the hero, until the form is on screen.
export const StickyCta = () => {
  const [scrolled, setScrolled] = useState(false);
  const [formVisible, setFormVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 640);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    const target = document.getElementById("qualify");
    const io = target && new IntersectionObserver(([e]) => setFormVisible(e.isIntersecting), { rootMargin: "0px 0px -40% 0px" });
    if (target) io.observe(target);
    return () => {
      window.removeEventListener("scroll", onScroll);
      io?.disconnect();
    };
  }, []);

  const show = scrolled && !formVisible;
  return (
    <div
      data-testid="sticky-cta"
      aria-hidden={!show}
      className={`lg:hidden fixed inset-x-0 bottom-0 z-40 bg-white/95 backdrop-blur border-t border-gray-200 px-4 py-3 transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"}`}
    >
      <CtaButton testId="sticky-cta-btn" className="w-full h-12" />
    </div>
  );
};
